// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2zOW2","row":"ProcedureTreatmentSummary_row__3c-og"};